import { Grid, TextField, Typography } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import React from 'react';
import { Controller, useFormContext, useController, get } from 'react-hook-form';
import usePlacesAutocomplete, { getGeocode, getZipCode } from 'use-places-autocomplete';

export const PlacesAutocomplete = (props) => {
    const { name, label, index, defaultValue } = props;
    const { meta } = useController(props);
    const [options, setOptions] = React.useState([]);
    const {
        suggestions: { data },
        setValue,
        clearSuggestions
    } = usePlacesAutocomplete({
        requestOptions: {
            componentRestrictions: { country: 'CA' },
            debounce: 300
        }
    });

    const methodes = useFormContext();
    const control = methodes.control;
    const error = get(methodes.formState.errors, props.name);
    const errorText = meta.invalid ? error.message : '';

    const [valueOpt, setvalueOpt] = React.useState('');

    const handleInput = (e, v, reason) => {
        if (reason === 'clear') {
            methodes.setValue(`applicants[${index}].address.location`, '');
        }
        setValue(e?.target?.value);
        let newOptions = [];
        if (valueOpt) {
            newOptions = [valueOpt];
        }
        if (data) {
            newOptions = [...data];
        }
        setOptions(newOptions);
        if (e?.target?.value === '') {
            clearSuggestions();
            setOptions([]);
        }
    };

    return (
        <Controller
            control={control}
            name={name}
            defaultValue={defaultValue}
            render={(props) => (
                <Autocomplete
                    autoComplete
                    getOptionLabel={(option) =>
                        typeof option === 'string' ? option : option.structured_formatting.main_text
                    }
                    {...props}
                    options={options}
                    filterOptions={(x) => x}
                    onInputChange={handleInput}
                    includeInputInList
                    freeSolo
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            label={label}
                            variant="outlined"
                            fullWidth
                            size="small"
                            error={!!errorText}
                            helperText={errorText ? errorText : props.helperText}
                            onChange={(e) => {
                                methodes.setValue(
                                    `applicants[${index}].address.location`,
                                    e?.target?.value,
                                    {
                                        shouldValidate: true
                                    }
                                );
                            }}
                        />
                    )}
                    onChange={(event, newValue) => {
                        if (newValue) {
                            const {
                                structured_formatting: { main_text: street, secondary_text }
                            } = newValue;
                            const [city, province] = secondary_text.replace(/ /g, '').split(',');
                            getGeocode({ address: newValue.description })
                                .then((results) => getZipCode(results[0], false))
                                .then((postalCode) => {
                                    methodes.setValue(
                                        `applicants[${index}].address.postalCode`,
                                        postalCode,
                                        {
                                            shouldValidate: true
                                        }
                                    );
                                });
                            methodes.setValue(`applicants[${index}].address.location`, street, {
                                shouldValidate: true
                            });
                            methodes.setValue(`applicants[${index}].address.city`, city, {
                                shouldValidate: true
                            });
                            methodes.setValue(`applicants[${index}].address.province`, province, {
                                shouldValidate: true
                            });
                        }

                        setvalueOpt(newValue);
                        clearSuggestions();
                        setOptions([]);
                    }}
                    renderOption={(option) => {
                        return (
                            <Grid container alignItems="center">
                                <Grid item xs>
                                    <span style={{ fontWeight: 400 }}>
                                        {option.structured_formatting.main_text}
                                    </span>
                                    <Typography variant="body2" color="textSecondary">
                                        {option.structured_formatting.secondary_text}
                                    </Typography>
                                </Grid>
                            </Grid>
                        );
                    }}
                />
            )}
        />
    );
};
